<template>
    <li>
        <router-link
            :event="!disabled ? 'click' : ''"
            :to="{ name: item.route }"
            v-on:click.native="$emit('menu-clicked')"
            :class="[{ menuItem__disabled: disabled }, 'menuItem']">
            <img :src="iconUrl" :alt="$t(item.labelTranslateKey)" class="menuItem__image"/>
            <span v-text="$t(item.labelTranslateKey)" :class="[{ menuItem__text__disabled: disabled }, 'menuItem__text']"></span>
        </router-link>
    </li>
</template>

<script>
export default {
    name: 'MenuItem',
    props: {
        item: {
            required: true,
            type: Object,
        },
        disabled: {
            required: true,
            type: Boolean,
        },
    },
    computed: {
        iconUrl() {
            return require(`@/assets/images/user-menu/${this.item.icon}`);
        },
    },
};
</script>
